import React, { useState, useEffect } from 'react';
import { isAuthenticated } from "../../store/action/auth";
import TransactionTable from "../../components/tables/TransactionTable";
import InvoiceTable from "../../components/tables/InvoiceTable";
import numeral from "numeral";
import Modal from "../../components/molecules/Modal"
import { FilterButton } from "../../components/buttons"
import ModalCalendar from '../order/components/ModalCalendar';
import { connect } from 'react-redux'
import { useDispatch } from "react-redux";
import QRModal from "../../components/atoms/QRModal";
import DownloadTransaction from '../../components/exports/excel/custom/DownloadTransaction';
import {
    getTransaction,
    getWallet,
    topUpWallet,
    postpaidRequest
} from "../../store/action/billing";
import {
    getInvoices
} from "../../store/action/invoice";
import {
    cancelTopUp
} from "../../store/action/transaction";
import ReactLoading from "react-loading";
import { Nav, Dropdown, DropdownButton } from 'react-bootstrap';
import {  APItoExcel } from './helpers/formatter';
import moment from 'moment';

const Billing  = (props) => {
    const dispatch = useDispatch();
    const [ transactions, setTransactions ] =  useState([]);
    const [ invoices, setInvoices ] =  useState([]);
    const [ modalLoading, setModalLoading ] = useState(false);
    const [ modalFilter, setModalFilter ] = useState(false);
    const [ loadingFilter, setLoadingFilter ] = useState(false);
    const [ tab, setTab ] = useState('transactions')
    const [ qrCode, setQrCode ] = useState([]);
    const [ values, setValues ] = useState({
        topUpAmount:0,
        transactionId:'',
    });
    const [ show, setShow ] = useState({
        modal:false,
        modalType:'topup'
    });
    const [ loading, setLoading ] = useState(true);
    const { token, user } = isAuthenticated();

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const resTrx = await getTransaction(token);
            const resInv = await getInvoices(token)
            dispatch(getWallet(token));
            if (resTrx.success && resInv.success) {
                let transactions = resTrx.transactions.sort((a, b) => {
                    var dateA = new Date(a.createdAt);
                    var dateB = new Date(b.createdAt);
                    return dateB - dateA;
                });
                let invoicesData = resInv.invoices.reduce((r,i) => {
                    r.push({
                        id:i.id,
                        invoiceNo:i.reference_id,
                        period:i.period,
                        dueDate:i.due_at,
                        total:i.total,
                        status:i.status
                    })
                    return r
                },[])
                setTransactions(transactions);
                setInvoices(invoicesData)
            } else {
                alert(`${resTrx.error}`)
            }
            setLoading(false)
        } catch (e) {
            console.log (e);
            alert(`${e.message}`)
        }
    };

    const onFilterTransaction = async (from, to) => {
        try {
            setLoadingFilter(true)
            const start = moment(from).format("YYYY-MM-DD");
            const end = moment(to).format("YYYY-MM-DD");
            const resTrx = await getTransaction(token,start,end);
            if (resTrx.success) {
                let transactions = resTrx.transactions.sort((a, b) => {
                    var dateA = new Date(a.createdAt);
                    var dateB = new Date(b.createdAt);
                    return dateB - dateA;
                });
                setTransactions(transactions);
            } else {
                alert(`${resTrx.error}`)
            }            
        } catch (e) {
            console.log (e);
            alert(`${e.message}`)
        }
        setModalFilter(false);
        setLoadingFilter(false);
    };

    const onSubmitTopUp = async () => {
        if (!values.topUpAmount) {
            alert("Mohon isi nominal terlebih dahulu ya");
            return
        }
        setModalLoading(true);
        try {
            const res = await topUpWallet(token, values.topUpAmount);
            if (res.success) {
                setShow({
                    ...show,
                    modal:false,
                    modalType:'confirmation',
                });
                setQrCode(res.qr_link);
                setValues({
                    ...values,
                    topUpAmount: res.amount,
                    transactionId: res.transaction_id
                })
            } else {
                alert("Gagal request top up wallet")
            }
        } catch (e) {
            console.log (e);
            alert(e.message)
        }
        setModalLoading(false)
    };

    const handleQRModalClose = async () => {
        if (window.confirm("Klik 'OK' jika Anda sudah bayar atau mau cancel top up ini")) {
            setModalLoading(true);
            setShow({...show,modalType:'',modal:true});
            setLoading(false);
            try {
                const res = await cancelTopUp(token, values.transactionId);

                if (res.success) {
                    window.location.reload()
                } else {
                    alert("Gagal cancel wallet")
                }
            } catch (e) {
                console.log (e);
                alert(e.message)
            }
        }
    };

    const handleModalClose = () => {
        setShow({...show, modal:false,modalType:''})
    };

    const handleChange = name => e => {
        setValues({...values, [name]: e.target.value})
    };

    const onClickTopUp = (modalType) => {
        setShow({...show, modal:true, modalType})
    };

    const requestPostpaid = async () => {
        try {
            let res = await postpaidRequest(token, user._id);

            if (res.success) {
                alert(res.message);
                window.location.reload()
            } else {
                alert(res.error)
            }
        } catch (e) {
            alert(e)
        }
    };

    const onModalConfirmation = (amount) => {
        setShow({
            ...show,
            modal:true,
            modalType:'confirmation'
        });
        setValues({
            topUpAmount:amount
        })
    };

    const modalView = () => {
        let body, size, title, type, bText, bClick, bodyClassName,removeHeader;

        if (show.modalType === 'topup' && !modalLoading) {
            removeHeader = false;
            title = "Jumlah Top Up";
            size = 'sm';
            type = 'oneButton';
            bText = 'Lakukan Pembayaran';
            bClick = () => onSubmitTopUp();
            bodyClassName="px-4 pt-4 pb-2";
            body = (
                <div className="form-row">
                    <div className="form-group input-group-sm col-md-12">
                        <select
                            id="inputState"
                            className="form-control"
                            onChange={handleChange('topUpAmount')}
                        >
                            <option
                                value=''
                                selected={`${values.topUpAmount === '' ? "selected":""}`}
                            >
                                Pilih...
                            </option>
                            <option
                                value='10000'
                                selected={`${values.topUpAmount === '10000' ? "selected":""}`}
                            >
                                {numeral(10000).format("0,0")} Pts
                            </option>
                            <option
                                value='20000'
                                selected={`${values.topUpAmount === '20000' ? "selected":""}`}
                            >
                                {numeral(20000).format("0,0")} Pts
                            </option>
                            <option
                                value='50000'
                                selected={`${values.topUpAmount === '50000' ? "selected":""}`}
                            >
                                {numeral(50000).format("0,0")} Pts
                            </option>
                            <option
                                value='100000'
                                selected={`${values.topUpAmount === '100000' ? "selected":""}`}
                            >
                                {numeral(100000).format("0,0")} Pts
                            </option>
                            <option
                                value='250000'
                                selected={`${values.topUpAmount === '250000' ? "selected":""}`}
                            >
                                {numeral(250000).format("0,0")} Pts
                            </option>
                        </select>
                    </div>
                </div>
            );
        } else if (modalLoading){
            removeHeader = true;
            size = 'sm';
            body = (
                <div className="text-center row">
                    <div className="col-2"/>
                    <div className="row col-10 py-2 py-2">
                        <ReactLoading
                            type={'bubbles'}
                            color={'#459BD8'}
                            height={32}
                            width={32}
                        />
                        <p className="mt-1 "><strong> Loading...</strong></p>
                    </div>
                </div>
            )
        }

        return (
            <Modal
                show={show.modal}
                onHide={handleModalClose}
                removeHeader={removeHeader}
                title={title}
                size={size}
                bodyClassName={bodyClassName}
                loading={loading}
                buttons
                type={type}
                bText={bText}
                bClick={bClick}
            >
                { body }
            </Modal>
        )
    };

    if (loading) {
        return (
            <div className="bg-white rounded shadow">
                <div className="p-4">
                    <div className="py-4">Loading...</div>
                </div>
            </div>
        )
    }

    const onNavChange = (t) => {
        setTab(t)
      };

    const nav = () => {
        if (props.wallet.type === 'postpaid') {
            return (
                <div className="row mr-0">
                    <div className="col-12 pt-2 pr-0 border-right address-window">
                    <Nav
                        className="px-4"
                        variant="tabs"
                        defaultActiveKey="/home"
                        onSelect={onNavChange}>
                        <Nav.Item>
                            <Nav.Link eventKey="transactions" active={tab === 'transactions'}>
                                Detail Transaksi
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="invoices" active={tab === 'invoices'}>
                                Tagihan Bulanan
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                    </div>
                </div>
            )
        }
    }
    return (
        <div className="mb-4">
            { modalView() }
            <QRModal
                show={show.modalType === 'confirmation'}
                onHide={() => handleQRModalClose()}
                qrCode={qrCode}
            />
            <ModalCalendar
                title={"Tanggal Transaksi"}
                show={modalFilter}
                onHide={() => setModalFilter(false)}
                buttons={true}
                loading={loadingFilter}
                type={"oneButton"}
                buttonText={"Filter"}
                buttonClick={onFilterTransaction}
            />
            <div className="bg-white rounded shadow">
                <div className="p-4">
                    <div className=" d-flex justify-content-between">
                        <div>
                            <h5>
                                Bite Points
                            </h5>
                            <h4 className="text-success">
                                {numeral(props.wallet.balance).format("0,0")} Pts
                            </h4>
                        </div>
                        <div className="d-flex">
                            {
                                props.wallet.type === 'requested' ?
                                    <div className="btn btn-secondary mr-4 text-muted disabled">
                                        Diajukan
                                    </div>
                                    :
                                    props.wallet.type === 'prepaid' ?
                                        <div>
                                            <button
                                                className="btn btn-primary mr-4"
                                                onClick={() => window.location.assign('/postpaid-registration')}
                                            >
                                                Ajukan Sistem Invoice Bulanan
                                            </button>
                                        </div>
                                        :
                                        <div className="mr-4">
                                            <h5 className="mb-0">Credit Bulanan Aktif</h5>
                                            <p className="text-muted">Pembayaran invoice bulanan</p>
                                        </div>
                            }
                            <div>
                                <button
                                    className="btn btn-sm btn-primary mr-4"
                                    onClick={() => window.location.assign('/billing/payout-form')}
                                >
                                    Tarik Saldo
                                </button>
                            </div>
                            <div>
                                {
                                    props.wallet.type === 'prepaid' ?
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => onClickTopUp('topup')}
                                        >
                                            Tambah Bite Points
                                        </button>: null
                                }
                            </div>
 
                        </div>
                    </div>
                </div>
            </div>

            <br/>
            <div className="bg-white rounded shadow">
                <div className="pt-4 px-4 pb-1 row align-items-center">
                    <div className="col">
                        <h5>Informasi Transaksi </h5>
                    </div>
                    <div className="col text-right">
                        <FilterButton onClick={() => setModalFilter(true)} className="btn-secondary border" iconClassName="fas fa-filter">
                            Filter
                        </FilterButton>
                        <DownloadTransaction data={APItoExcel(transactions)}/>
                    </div>
                </div>
                {nav()}
                {
                    tab === 'transactions' ?
                        <TransactionTable
                            data={transactions}
                            onModalConfirmation={onModalConfirmation}
                            loading={loading}
                        />
                        :
                        <InvoiceTable
                            data={invoices}
                            loading={loading}
                        />
                }
               
            </div>
        </div>
    )
};

export default connect(state => ({ wallet: state.wallet}), {})(Billing)
